import { Controller } from "stimulus"
import consumer from "../channels/consumer"

const TERMINAL_STATUSES = ['processed', 'processed_with_error'];

export default class extends Controller {
  static targets = ['status', 'updatedAt', 'text'];

  connect() {
    if (TERMINAL_STATUSES.indexOf(this.statusTarget.value) !== -1) return;

    this.subscription = consumer.subscriptions.create(
      { channel: 'AuditOutputChannel', id: this.data.get('id') },
      { received: (data) => this.updateLog(data) }
    );
  }

  disconnect() {
    this.unsubscribe();
  }

  updateLog(data) {
    $(this.statusTarget).val(data.status).trigger('change');

    if (this.hasUpdatedAtTarget) this.updatedAtTarget.value = data.updated_at;

    var wrapper = this.textTarget.nextSibling;
    var editor = wrapper && wrapper.CodeMirror;
    if (editor) {
      editor.setValue(data.output);
      editor.scrollTo(0, editor.getScrollInfo().height);
    } else {
      this.textTarget.value = data.output;
    }

    if (TERMINAL_STATUSES.indexOf(data.status) !== -1) this.unsubscribe();
  }

  unsubscribe() {
    if (this.subscription) {
      consumer.subscriptions.remove(this.subscription);
      this.subscription = null;
    }
  }
}
